import { useState } from "preact/hooks"
import { Modal, ModalWrapper } from "src/utils/fw"
import { useLocalStorage } from "src/utils/hooks"

export default ({roomName = null}) => {
    const full = {width: "100%"}
    const inputStyle = {
        ...full,
        display: "block",
        background: "rgba(255,255,255, .5)",
        border: 0,
        padding: "15px 10px",
        borderRadius: "3px"
    }

    const dismiss = {
        padding: "6px 7px", 
        textAlign: "center", 
        lineHeight: ".8",
        fontSize: "21px",
        borderRadius: "100%", 
        background: "rgba(255,255,255,.5)",
        width: undefined,
        height: undefined,
        right: "5px",
        top: "5px"
    }

    const linkStyle = {
        color: "white"
    }

    const [isDisplayed, setIsDisplayed] = useLocalStorage(roomName || `displayOnce-IBM-terms-a`)
    const [phone, setPhone] = useState("")
    const [email, setEmail] = useState("")
    const [load, setLoad] = useState({
        loading: false,
        msg: "",
        type: "waiting"
    })

    const submitHdlr = (ev) => {
        ev.preventDefault();
        const eventId = window.dataLayer[0]["Event ID"]
        const registrantId = window.dataLayer[0]["Registrant ID"]
        const data = { eventId, registrantId, phone, email }
        setLoad(it => {
            return {...it, loading: true}
        })

        fetch("https://popupfunctions.tkevents.io/create/" + eventId, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(() => {
            setLoad(it => {
                return {...it, loading: false, type: "done", msg: "Thanks for your submission!"}
            })
        }).catch(() => {
            setLoad(it => {
                return {...it, loading: false, type: "error", msg: "try again"}
            })
        })
    }

    if (load.type === "done") {
        setTimeout(() => {
            setLoad(it => {
                return {...it, type: "hide"}
            })
            setIsDisplayed(true)
        }, 1000)
    }
    if (isDisplayed || load.type === "hide") return <></>

    return <Modal dismissHTML="X" dismissStyle={dismiss} dismiss={() => {
        setIsDisplayed(true)
    }}>
        <ModalWrapper wrapperStyle={{backgroundColor: "rgb(59, 80, 206)", color: "white", textAlign: "center", maxWidth: "433px", fontSize: "medium"}}>
            <h1>IBM</h1>
            <p>Consent/Acceptance of Data Privacy Statement:</p>
            <p>
                I’d like my contact details to be shared with IBM so they can keep me informed about products,
                services, and offers. More information on how IBM uses data and ways to <a style={linkStyle} title="IBM Optout" id="IBM Optout" href="https://ibm.biz/marketingoptout">opt out</a> can be found in the 
                <a style={linkStyle} title="IBM Privacy Statement" id="IBM Privacy Statement" href="https://www.ibm.com/us-en/privacy">IBM Privacy Statement.</a> 
            </p>
            <p>
                California residents, review our <a style={linkStyle} href="https://www.ibm.com/us-en/privacy/ccpa" id="Privacy Choices" label="Privacy Choices">notice and your privacy choices.</a>
            </p>
            {load.type !== "done" && 
                <form onSubmit={submitHdlr}>
                    <div style={{textAlign: "left", display: "flex", flexDirection: "column", alignItems: "center"}}>
                        <div style={{...full, display: "flex", justifyContent: "center"}}>
                            <div style={{...full, marginRight: "20px"}}>
                                <label style={{display: "block", marginBottom: "10px"}}>
                                        By Email *
                                </label>
                                <input disabled={load.loading} style={inputStyle} value={email} required name="email" type="email" placeholder="Email" onChange={ev =>{setEmail(ev.target.value)}}/> 
                            </div>
                            <div style={full}>
                                <label style={{display: "block", marginBottom: "10px"}}>
                                    By telephone
                                </label>
                                <input disabled={load.loading} style={inputStyle} value={phone} required name="telephone" type="phone" placeholder="Telephone" onChange={ev =>{setPhone(ev.target.value)}}/>
                            </div>
                        </div>
                        <div style={{marginTop: "20px"}}>
                            <button type="submit" style={{
                                    padding: "15px 30px",
                                    borderRadius: "4px",
                                    border: 0,
                                    fontWeight: "bold",
                                    color: "white",
                                    background: "#187bff",
                                    cursor: "pointer"
                            }}>
                                Submit
                            </button>
                        </div>
                    </div>
                </form>
            }
            {
                load.type === "done" && <p>{load.msg}</p>
            }
        </ModalWrapper>
    </Modal>
}